import { mixed, number, object, string } from 'yup'

import { DDE_USER_ROLES, USER_ROLE as DDE_USER_ROLE } from '@img-arena/consoles-api-dde'
import {
  USER_ROLE as DGE_USER_ROLE,
  USER_ROLES as DGE_USER_ROLES
} from '@img-arena/consoles-api-streaming'
import { UserRole } from '@/types/streams/role'

const DDE_userFormValidationSchema = object().shape({
  userName: string().required('Username is required'),
  email: string().email('Invalid email').required('Email is required'),
  role: string().oneOf(DDE_USER_ROLES).required('Role is required'),
  operator: mixed().when('role', {
    is: DDE_USER_ROLE.OPERATOR,
    then: () => string().required('Operator is required'),
    otherwise: (schema) => schema.empty('Operator field should be empty for Admin role')
  })
})

export const DGE_ROLES_THAT_NEED_OPERATOR = [DGE_USER_ROLE.OPERATOR, DGE_USER_ROLE.TRADER]

const DGE_userFormValidationSchema = object().shape({
  fullName: string().required('Full Name is required'),
  email: string().email('Invalid email').required('Email is required'),
  mainNumber: number()
    .integer('Contact number should be an integer')
    .positive('Contact number should be a positive number')
    .typeError('Contact number should be a number')
    .nullable()
    .test('length', 'Contact number should be between 4 and 16 digits', (value) =>
      value ? value.toString().length >= 4 && value.toString().length <= 16 : true
    ),
  role: string().oneOf(DGE_USER_ROLES).required('Role is required'),
  company: mixed().when('role', {
    is: DGE_USER_ROLE.ENGINEER,
    then: (schema) => schema.required('Company is required'),
    otherwise: (schema) => schema.empty('Company field should be empty for non-Engineer roles')
  }),

  operator: mixed().when('role', {
    is: (role: UserRole) => DGE_ROLES_THAT_NEED_OPERATOR.some((r) => r === role),
    then: () => string().required('Operator is required'),
    otherwise: (schema) =>
      schema.empty('Operator field should be empty for non-Operator, non-Trader, non-IMG roles')
  })
})

export const userFormValidationSchema = {
  DDE: DDE_userFormValidationSchema,

  DGE: DGE_userFormValidationSchema
}
